import React from 'react';
import AdminV2AI from '../../admin-v2/ai';

/** Manager V2 AI — shell réutilisant AdminV2AI. Feature : pages.ai.manager. */
const ManagerV2AI = () => <AdminV2AI titleKey="aiV2.managerTitle" titleFallback="AI assistant" />;

export default ManagerV2AI;
